export default __webpack_public_path__ + "static/media/voice.84d5cb77.svg";